// @flow
import * as React from 'react'
import { Row } from '../../Row'

// Types
export type Props = {
  children: React.Node,
}

/**
 * A component aimed to show a horizontal list of buttons. It adds a unified
 * space between buttons in a row and allow the buttons to be wrapped when
 * they can't be displayed in a row
 * @param       {React.Children} children
 */
function ButtonsGroup({ children }: Props) {
  return (
    <Row wrap="auto" flexible verticalGutter edgeGutter>
      {children}
    </Row>
  )
}

export default ButtonsGroup
